import React from "react";
import { Route, Switch } from "react-router-dom";
import { addFonts } from "./common/assets/Icons";
import "./App.css";
import BankFindApp from "./containers/BankFind";
import BankFindDetails from "./containers/BankFindDetails";
import StructureChange from "./containers/StructureChange";
import BankFindSuite from "./components/BankFindSuite/BankFindSuite";
import FinancialReporting from "./components/FinancialReporting/FinancialReporting";
import HistoricalBankData from "./containers/HistoricalBankData";
import HelpContentCB from "./components/HelpContent/HelpContentCB";
import HelpContentSI from "./components/HelpContent/HelpContentSI";
import HelpContentFailures from "./components/HelpContent/HelpContentFailures";
import BankFailures from "./containers/BankFailures";
import FinancialReportingDetails from "./containers/FinancialReportingDetails";
import Help from "./components/HelpContent/Help";
import StandardComparison from "./containers/StandardComparison";
import CustomizedComparison from "./containers/CustomizedComparison";
import CustomizedSearch from "./containers/CustomizedSearch";
import ManageSavedPeerGroups from "./containers/ManageSavedPeerGroups";
import DefineCustomReport from "./components/PeerGroup/DefineCustomReport";
import DefineCustomPeerGroups from "./containers/DefineCustomPeerGroups";
import PrivateRoute from "./components/PrivateRoute";
import SOD from "./components/SOD/SOD";
import BranchOfficeDeposits from "./containers/BranchOfficeDeposits";
import SummaryTables from "./containers/SummaryTables";
import HealthDashboard from "./components/HealthDashboard/HealthDashboard";
import MarketShare from "./containers/MarketShare";
import MaintenanceDashboard from "./components/Maintenance/MaintenanceDashboard";
import CustomDataDownload from "./containers/CustomDataDownload";
import FinancialReportingSearchReport from "./containers/FinancialReportingSearchReport";
import BulkDataApi from "./components/BulkData/BulkDataAPI";
import API101 from "./components/BulkData/API101";
import BulkDataDownload from "./components/BulkData/BulkDataDownload";

addFonts();

interface Props {
  uuid: string;
  updateApp: (app: string) => void;
}

export default function App({ uuid, updateApp }: Props) {
  return (
    <Switch>
      <Route
        exact
        path="/bankfind"
        render={() => {
          updateApp("bankFind");
          return <BankFindApp />;
        }}
      />
      <Route
        exact
        path="/bankfind/details/:cert"
        render={() => {
          updateApp("bankFind");
          return <BankFindDetails />;
        }}
      />
      <Route
        exact
        path={["/oscr", "/oscr/:eventType"]}
        render={() => {
          updateApp("structureChange");
          return <StructureChange />;
        }}
      />
      <Route
        exact
        path={["/financialreporting", "/peergroup"]}
        render={() => {
          updateApp("financialReporting");
          return <FinancialReporting />;
        }}
      />
      <Route
        exact
        path={"/financialReporting/report"}
        render={() => {
          updateApp("financialReporting");
          return <FinancialReportingSearchReport />;
        }}
      />
      <Route
        exact
        path="/financialreporting/details/:cert"
        render={() => {
          updateApp("financialReporting");
          return <FinancialReportingDetails />;
        }}
      />
      <Route
        exact
        path="/SOD"
        render={() => {
          updateApp("SOD");
          return <SOD />;
        }}
      />
      <Route
        exact
        path="/SOD/branchOffice"
        render={() => {
          updateApp("SOD");
          return <BranchOfficeDeposits />;
        }}
      />
      <Route
        exact
        path="/SOD/customDownload"
        render={() => {
          updateApp("SOD");
          return <CustomDataDownload />;
        }}
      />
      <Route
        exact
        path="/SOD/summaryTables"
        render={() => {
          updateApp("SOD");
          return <SummaryTables />;
        }}
      />
      <Route
        exact
        path="/SOD/marketShare"
        render={() => {
          updateApp("SOD");
          return <MarketShare />;
        }}
      />
      <Route
        exact
        path="/peergroup/standard"
        render={() => {
          updateApp("peerGroup");
          return <StandardComparison />;
        }}
      />
      <Route
        exact
        path="/peergroup/customized"
        render={() => {
          updateApp("peerGroup");
          return <CustomizedComparison />;
        }}
      />
      <Route
        exact
        path="/peergroup/customized/search"
        render={() => {
          updateApp("peerGroup");
          return <CustomizedSearch />;
        }}
      />
      <Route
        exact
        path="/peergroup/manage"
        isAuthenticated={uuid}
        redirect="/peergroup"
        component={() => {
          updateApp("peerGroup");
          return <ManageSavedPeerGroups />;
        }}
      />
      <PrivateRoute
        exact
        path="/peergroup/definegroup"
        redirect="/peergroup"
        isAuthenticated={uuid}
        component={() => {
          updateApp("peerGroup");
          return <DefineCustomPeerGroups />;
        }}
      />
      <PrivateRoute
        exact
        path="/peergroup/definereport"
        redirect="/peergroup"
        isAuthenticated={uuid}
        component={() => {
          updateApp("peerGroup");
          return <DefineCustomReport />;
        }}
      />
      <Route
        exact
        path="/historical"
        render={() => {
          updateApp("historical");
          return <HistoricalBankData />;
        }}
      />
      <Route
        exact
        path="/historical/help/CB"
        render={() => {
          updateApp("historical");
          return <HelpContentCB />;
        }}
      />
      <Route
        exact
        path="/historical/help/SI"
        render={() => {
          updateApp("historical");
          return <HelpContentSI />;
        }}
      />
      <Route
        exact
        path="/failures"
        render={() => {
          updateApp("failures");
          return <BankFailures />;
        }}
      />
      <Route
        exact
        path="/failures/help"
        render={() => {
          updateApp("failures");
          return <HelpContentFailures />;
        }}
      />
      <Route
        exact
        path="/bulkData"
        render={() => {
          updateApp("bulkData");
          return <BulkDataApi />;
        }}
      />
      <Route
        exact
        path="/bulkData/api101"
        render={() => {
          updateApp("bulkData");
          return <API101 />;
        }}
      />
      <Route
        exact
        path="/bulkData/bulkDataDownload"
        render={() => {
          updateApp("bulkData");
          return <BulkDataDownload />;
        }}
      />
      <Route
        exact
        path="/help"
        render={() => {
          return <Help />;
        }}
      />
      <Route
        exact
        path="/admin/health"
        render={() => {
          updateApp("adminHealthDashboard");
          return <HealthDashboard />;
        }}
      />
      <Route
        exact
        path="/admin/maintenance"
        render={() => {
          updateApp("maintenanceDashboard");
          return <MaintenanceDashboard />;
        }}
      />
      <Route path="*" component={BankFindSuite} />
    </Switch>
  );
}
